<template>
    <div id="fabric-js-container" ref="fabricJSContainer">
        <canvas id="fabric-js-canvas" class="workspace-module-container" ref="fabricJS"></canvas>
    </div>
</template>

<script>
    import {urlForFileStorage} from "../common";
    import {fabricEditor} from "../../fabric/fabricMain";
    import {bus} from "../../vue_bus";
    import {threeMain} from "../../threeJS/threeMain";

    export default {
        name: "WorkspaceFabric.vue",
        mixins: [urlForFileStorage],
        mounted() {
            this.initFabric();
            bus.$on("selectedPlaneFromPlaneVisualisator", (planeID) => {
                if (planeID === this.$route.params.planeID)
                    return;

                    // const plane = this.$store.getters["active/PLANE_BY_ID"](planeID);
                    // this.$store.dispatch("active/SET_ID_DESIGN_GROUP_ACTIVE_PLANE", this.$route.params.groupID)
                // const activeProjectGUID = this.$route.params.projectUUID;
                // const idActivePhoto = this.$route.params.photoID;
                // this.$store.commit(`projectList/${activeProjectGUID}` +
                //                         `/photoList/${idActivePhoto}` +
                //                         `/planeList/${planeID}` +
                //                         `/ID_DESIGN_GROUP`,
                //     this.$route.params.groupID);

                    // if(!plane)
                    //     return;
                    //
                    // console.log(plane);

            })
        },
      beforeDestroy() {
        // let params = Object.assign({}, this.$route.params);
        // delete params.view;
        // this.$router.replace({ params }).catch(()=>{});
      },
      destroyed() {
            bus.$off("dblclickPlaneFromPlaneVisualisator");
            bus.$off("selectedPlaneFromPlaneVisualisator");
            this.editor.destroy();
        },
        computed: {
            activePhotoAbsoluteURL() {
                return this.urlForFileStorage(this.$store.getters[`active/GET_ACTIVE_PHOTO`].src);
            },
            activeDesign() {
                return this.$route.params.designID;
            },
            activeProduct() {
                return this.$route.params.productUUID;
            },
        },
        methods: {
          initFabric: async function () {
            this.editor = new fabricEditor(this.$refs["fabricJS"]);
            this.editor.updateCanvaSize({
                  width: this.$refs["fabricJSContainer"].offsetWidth,
                  height: this.$refs["fabricJSContainer"].offsetHeight
                }
            );
            let source = await this.editor.addSourceImage(this.activePhotoAbsoluteURL);
            await this.editor.addPlaneGroupingTool();
            this.editor.setViewport(source, 1);
          }
        }
    }
</script>

<style scoped>
    #fabric-js-container {
        width: 100%;
        height: 100%;
    }
</style>
